import {
  OPCOES_TELA_RENDA,
  OPCOES_CARD,
  RESETA_OPCOES_TELA_RENDA,
  OPCOES_TELA_BENEFICIARIOS,
} from './constants';

export function opcoesTelaRenda(values) {
  return {
    type: OPCOES_TELA_RENDA,
    values,
  };
}

export function resetaOpcoesTelaRenda() {
  return {
    type: RESETA_OPCOES_TELA_RENDA,
  };
}

export function opcoesCard(values) {
  return {
    type: OPCOES_CARD,
    values,
  };
}

export function opcoesTelaBeneficiarios(values) {
  return {
    type: OPCOES_TELA_BENEFICIARIOS,
    values,
  };
}
